/**
 * Runs asynchronous tasks one at a time, in the order they were requested, so
 * that two runs of the same job can never interleave their steps.
 *
 * Each task is handed an `isCurrent()` predicate to check at its own await
 * points: once a newer task has been queued, a long-running one can stop early
 * and leave the rest of the work to its replacement.
 */
export const createSerialQueue = () => {
  let latestID = 0;
  let tail: Promise<void> = Promise.resolve();

  const queue = (task: (isCurrent: () => boolean) => Promise<void> | void) => {
    const id = ++latestID;
    const run = tail.then(() => task(() => id === latestID));
    // Chain on a caught copy so one failed task doesn't block the queue.
    tail = run.catch(() => {});
    return run;
  };

  return queue;
};
